<script setup lang="ts">
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-vue';
import { Hub } from 'aws-amplify/utils';
import '@aws-amplify/ui-vue/styles.css';
import { navigateTo, useNuxtApp } from 'nuxt/app';

// ページの設定
definePageMeta({
  layout: 'login'
});

// 認証の監視
const auth = useAuthenticator();
let init = false;

const { $auth } = useNuxtApp();
const token = await $auth.getToken();

if (token !== null) {
  navigateTo({ path: 'mypage' });
} else {
  init = true;
}

const restoreUrl = $auth.getRestoreUrl();

const listener = (data: any) => {
  if (data.payload.event === 'signedIn') {
    navigateTo(restoreUrl);
    $auth.clearRestoreUrl();
  }
};

Hub.listen('auth', listener);

const initialState = restoreUrl.query.initial_state ?? 'signIn';

</script>
<template>
  <div v-if="init" class="pt-5">
    <div class="text-center mb-5">
      <img src="@/assets/image/logo.png" style="height: 40px; width: auto;"/>
    </div>
    <authenticator :login-mechanisms="['email']" :initialState="initialState"></authenticator>
    <template
      v-if="auth.route === 'signIn'"
    >
      <div class="container mt-5">
        <div class="row">
          <div class="col-sm-12 col-md-6 offset-md-3">
            <div class="alert alert-info ml-2 me-2">
              認証システムの変更にともない、2023年10月6日以降に再度ログインする場合には、パスワード変更をお願いします。
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
